'use client';

import { setExperimentCookieOnClient } from '@/lib/utils/analyticsHelper';
import { useEffect } from 'react';

export default function CookieSetter({ uuid }: { uuid: string }) {
  useEffect(() => {
    setExperimentCookieOnClient(uuid);
  }, []);
  return null;
}
